import * as React from 'react';
import { NavBarTypes } from './navBarTypes';
import { weakKey } from '../../../../utilities/weakKey';
import {
  NavBarLogoIconAndBurgerHelper,
  NavBarMenuHelper,
} from './helpers/NavBarLogoAndMenuHelper';

export const NavBarVariant = ({
  iconsConfig,
  facilityDetails,
  phoneNumber,
  phoneNumberRedirect,
  locationType,
  handleNavBarFunctions,
  openNavBar,
  LinkWrapper,
  navLinks,
  socialIconsandUrls,
  renderPhoneNumberIcon,
  buttonsConfig,
  globalContext,
  logOutHandler,
}: NavBarTypes.TVariantDataType) => {
  const handlenavbarBurgerState = () => {
    handleNavBarFunctions.handleNavBarBurgerState();
  };
  const socialMediaIconsAndState = {
    socialIconsandUrls,
    handlenavbarBurgerState,
    openNavBar,
  };
  return (
    <>
      <NavBarLogoIconAndBurgerHelper
        facility={facilityDetails}
        iconsConfig={iconsConfig}
        phoneNumber={phoneNumber}
        phoneNumberRedirect={phoneNumberRedirect}
        locationType={locationType}
        handlenavbarBurgerState={handlenavbarBurgerState}
        handleNavBarStateForLogo={
          handleNavBarFunctions.handleNavBarStateForLogo
        }
        openNavBar={openNavBar}
        key={weakKey(facilityDetails)}
      />

      <NavBarMenuHelper
        openNavBar={openNavBar}
        navLinks={navLinks}
        locationType={locationType}
        socialMediaIconsAndState={socialMediaIconsAndState}
        iconsConfig={iconsConfig}
        renderPhoneNumberIcon={renderPhoneNumberIcon}
        buttonsConfig={buttonsConfig}
        handleNavBarFunctions={handleNavBarFunctions}
        LinkWrapper={LinkWrapper}
        globalContext={globalContext}
        logOutHandler={logOutHandler}
      />
    </>
  );
};
